// TODO: Impl
import * as React from "react";
import "./styles.scss";

interface SideBarProps {
    onClickLink?: () => void;
    primary?: boolean;
    href?: string;
    children: string;
}

const SideBarLink = ({
    onClickLink,
    primary = false,
    href,
    children
}: SideBarProps) => {
    return (
        <a
            className={primary ? "sidebar-link primary" : "sidebar-link"}
            onClick={onClickLink}
            href={href}
            target="_blank"
            rel="noreferrer noopener"
        >
            {children}
        </a>
    );
};

export default SideBarLink;
